import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MessageModal from "../components/MessageModal";
import { SpinnerLoader } from "../components";
import StoreService from "../services/StoreService";
import { STORE_ID_DEFAULT } from "../constants/businessValues";
import { errorConection } from "../utils";

export const MessagesControl = () => {
  let engineInterval: any;
  const navigation = useNavigate();
  const { state } = useLocation(); // "{\"code\": \"0\", \"msg\": \"OK\", \"role\": \"customer\"}"
  const { userLogged } = useSelector((state: any) => state.session);
  const [apiMsg, setApiMsg] = useState(false);
  const [titleSelected, setTitleSelected] = useState("");
  const [descSelected, setDescSelected] = useState([]);
  const [actionsSelected, setActionsSelected] = useState([]);

  const startInterval = () => {
    engineInterval = setInterval(() => accessStatus(), 2000);
  };

  const stopInterval = () => {
    clearInterval(engineInterval);
  };

  // FUNCION QUE PIDE MENSAJES CONSTANTEMENTE SOBRE ESTATUS DE LA PUERTA Y PAGO
  const accessStatus = async () => {
    StoreService.getAccessStatus(userLogged.login, STORE_ID_DEFAULT).then(
      (data) => {
        if (data instanceof Error) {
          errorConection("TypeError: Network request failed");
        } else if (data.result.length > 0) {
          stopInterval();
          const accessStoreResponse = data.result[0];
          const codeResponse = parseInt(accessStoreResponse.code);
          if (codeResponse === 7) {
            navigation("/cart");
          } else {
            configMsgByCode(codeResponse);
          }
        }
      }
    );
  };

  // Funcion para estructurar modal de notificacion y que accione el usuario
  // abrir flujo acompañantes
  const configMsgByCode = (codeResponse: any) => {
    const elementCode: any = messagesByCodeDoor.find(
      (el) => el.code === codeResponse
    );

    setTitleSelected(elementCode.title);
    setDescSelected(elementCode.description);
    setActionsSelected(elementCode.actions);
    setApiMsg(true);
  };

  const messagesByCodeDoor = [
    // 14- Tienda Cerrada
    {
      code: 14,
      icon: () => {},
      title: "Tienda Cerrada",
      description: ["Tienda cerrada"],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    // 2 - Hay mas de un cliente en el hall. Deben ingresar de a uno
    {
      code: 2,
      icon: () => {},
      title: "Salir a la vereda",
      description: ["El numero de personas en el hall excede el permitido."],
      actions: [
        {
          title: "Salir",
          colorPrimary: true,
          onClick: () => {
            setApiMsg(false);
            startInterval();
          },
        },
      ],
    },
    // 4 - Usuario no ingresa o no es detectado en el hall de ingreso
    {
      code: 4,
      icon: () => {},
      title: "Usted no ingresó",
      description: ["No se ha detectado el ingreso a la tienda."],
      actions: [
        {
          title: "Volver a intentarlo",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    // 5 - Usuario confirmo y no ingresó a la tienda
    {
      code: 5,
      icon: () => {},
      title: "Salir del hall de ingreso",
      description: [
        "Por favor, no permanecer en el hall de ingreso.",
        "Una vez confirmado, ingresar a la tienda.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    // 6 - se debe abrir la puerta 1 indefinidamente hasta que salga
    {
      code: 6,
      icon: () => {},
      title: "Error de registración",
      description: ["Por favor, salir del hall de ingreso."],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/cart");
          },
        },
      ],
    },
    // 8 - No entraste reinicia flujo
    {
      code: 8,
      icon: () => {},
      title: "Salir del hall de ingreso",
      description: [
        "Por favor, no permanecer en el hall de ingreso.",
        "Debe retirarse del hall.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/cart");
          },
        },
      ],
    },
    {
      code: 10, // Usuario confirmo y no ingresó a la tienda
      icon: () => {},
      title: "--",
      description: ["Saliste de la tienda"],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 100, // Usuario confirmo y no ingresó a la tienda
      icon: () => {},
      title: "Pago realizado",
      description: ["El pago fue procesado con éxito"],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 111, // Usuario confirmo y no ingresó a la tienda
      icon: () => {},
      title: "Usted se ha retirado",
      description: ["Se ha retirado sin productos en la tienda."],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 12, // multiples grupos en salida
      icon: () => {},
      title: "Volver a la tienda",
      description: [
        "Su grupo debe volver a la tienda.",
        "Solo puede salir un grupo a la vez.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            setApiMsg(false);
          },
        },
      ],
    },
    {
      code: 13, // grupo incompleto
      icon: () => {},
      title: "Grupo incompleto",
      description: [
        "Todos los integrantes de tu grupo deben estar en el hall para avanzar con el pago o salir de la tienda.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            setApiMsg(false);
          },
        },
      ],
    },
  ];

  useEffect(() => {
    postAccessRequest((state as any)?.res);
    return () => stopInterval();
  }, [state]);

  // Pide acceso a puerta si falla debe salir
  const postAccessRequest = async (response: any) => {
    if (response) {
      const accessStoreResponse = JSON.parse(response);
      const codeResponse = parseInt(accessStoreResponse.code);

      // 0 es el primer acceso OK
      if (codeResponse === 0) {
        startInterval();
      } else if (codeResponse === 14) {
        configMsgByCode(codeResponse);
        stopInterval();
      } else {
        const elementCode: any = messagesByCodeDoor.find(
          (el) => el.code === codeResponse
        );

        setTitleSelected(elementCode.title);
        setDescSelected(elementCode.description);
        setActionsSelected(elementCode.actions);
        setApiMsg(true);
      }
    }
  };

  return !apiMsg ? (
    <SpinnerLoader />
  ) : (
    <div>
      <MessageModal
        type="text"
        Icon={() => {}}
        title={titleSelected}
        text={descSelected}
        actions={actionsSelected}
        handleClose={() => setApiMsg(false)}
        open={apiMsg}
      />
    </div>
  );
};
